<template>
  <div class="account_container orderMb">
    <div class="main-content">
      <div class="order-filters">
        <p @click="selectFilter('all')" :class="filterSelected === 'all' ? 'filter-selected' : 'filter-notSelected'" >
          {{ $t('all_afm') }}</p>
        <p @click="selectFilter('pending')" :class="filterSelected === 'pending' ? 'filter-selected' : 'filter-notSelected'">
          {{ $t('pending_payment') }}</p>
        <p @click="selectFilter('processing')" :class="filterSelected === 'processing' ? 'filter-selected' : 'filter-notSelected'">
          {{ $t('processing') }}</p>
        <p @click="selectFilter('completed')" :class="filterSelected === 'completed' ? 'filter-selected' : 'filter-notSelected'">
          {{ $t('completed') }}</p>
      </div>
      <div v-show="loggedIn===true" class="page-width customers_acc">
        <div class="grid">
            <div class="order-header" v-if="filteredList.length > 0 && !isMobile">
              <p class="col-head">{{ $t('delivery') }}</p>
              <p class="col-head">{{ $t('orderNo') }}</p>
              <p class="col-head">{{ $t('Status') }}</p>
            </div>
            <div  class="continue-shopping" v-if="filteredList.length===0 && !ordersLoading">
              <p class="nodata">{{$t('no_orders')}}</p>
              <button @click="continueShopping">{{ $t('continueShopping') }}</button>
            </div>
            <div class="profile-loading" v-if="ordersLoading">
              <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                width="120px" height="120px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                <path fill="#7cc26a" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
                  <animateTransform attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 25 25"
                    to="360 25 25"
                    dur="1s"
                    repeatCount="indefinite"
                  />
                </path>
              </svg>
            </div>
            <div>
              <ul class="order-tbl" v-if="!isMobile">
                <li v-for="(order, index) in filteredList" data-index="index" :key="index" class="order-row">
                  <p class="order-col" v-bind:data-label="$t('delivery')" nowrap="nowrap">
                    {{order.DispatchDate}}<br/>{{order.TimeRange}}
                  </p>
                  <p class="order-col pointer" v-bind:data-label="$t('order')" @click="toggleModal(order)">
                      #{{order.SONum}}
                  </p>
                  <p class="order-col ffiteen delivered"
                     v-if='order.SaleStatus==="Delivered"'
                     v-bind:data-label="$t('fulfillmentStatus')">
                    {{ $t('inTransit') }}
                  </p>
                  <p class="order-col fifteen open"
                     v-if='order.SaleStatus!=="Delivered"'
                     v-bind:data-label="$t('fulfillmentStatus')">
                    {{curIsEnglish ? order.SaleStatus : order.SaleStatus_chinese}}
                  </p>
                  <div class="order-col ten order-btn-container">
                    <p  @click="navTo(order.SalesOrder_id)"
                        class="underline big">
                      {{ $t('view_details') }}
                    </p>
                    <p  @click="reorder(order, $event)"
                        class="underline big">
                      {{ $t('reorder') }}
                    </p>
                  </div>
                </li>
              </ul>
              <mobileOrder
                v-else
                :filteredList="filteredList"
                @toggleModal="toggleModal"
                @navTo="navTo"
                @reorder="reorder"
              >
              </mobileOrder>
            </div>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import $ from "jquery";

import {locales} from "../../mixin";
import mobileOrder from "../../components/mobile/mobile-order";
import {flyToElement, isUserAuthenticated} from "../../store/modules/cart";

export default {
  name: "account-order",
  mixins: [locales],
  components: {
    mobileOrder
  },
  data(){
    return{
      orderTimeFrame:[],
      filterSelected: 'all',
      loaded: false,
      option: '',
      options: [{
        value: '1',
        label: 'last3Month'
      }, {
        value: '2',
        label: 'last6Month'
      }, {
        value: '3',
        label: 'last12Month'
      },{
        value: '4',
        label: 'all'
      },],
       tabs: [
        {
          name: 'All',
          displayName: '全部訂單',
        },
        {
          name: 'Pending',
          displayName: '待付款',
        },
        {
          name: 'Processing',
          displayName: '處理中',
        },
        {
          name: 'Shipped',
          displayName: '已發貨',
        },
      ],
      activeTabName: null,
      list:[],
    }
  },
  methods:{
    ...mapMutations('auth', ['logout', 'updateLoginStatus']),
    ...mapActions('orders', ['fetchOrderByTimeFrame','cancelOrder','fetchConsolidatedOrders','fetchSODetails']),
    ...mapMutations('orders', ['toggleOrderModal', 'setOrderId']),
    ...mapActions('cart',['addProductToCart']),
    navTo(id) {
      this.$router.push({name: 'order', params: {order_id: id}});
    },
    selectFilter(filter) {
      this.filterSelected = filter;
    },
    continueShopping() {
      this.$router.push('/collections');
    },
    toggleModal(order) {
      this.setOrderId(order)
      this.toggleOrderModal(true)
    },
    // 再来一单
    async reorder(order, event) {
      if (!isUserAuthenticated()) {
        return this.$store.dispatch('cart/addProductToLocalCart', item)
          .then(() => {
            this.$store.dispatch('cart/getCart');
            flyToElement(event.target, $('.cart-link'));
          })
      }
      const res = await this.fetchSODetails(order.SalesOrder_id)
      const resData = res.data
      if (!resData || !Array.isArray(resData.Sales_Order_Line)) {
        return
      }
      resData.Sales_Order_Line.forEach(item => {
        this.addToCart(item, event)
      })
    },
    addToCart: function (item) {
      this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item.item || item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
        });
    },
    handleAddToCartFail() {
      alert('Not enough product in stock');
    },
  },
  mounted() {
    // 问题：手机登录后，立马点击我的订单，是一直会转圈圈，不能显示订单详情，切换到其它界面，再回来，就可以显示订单详情页面
    // 因为调用Vuex中fetchOrderByTimeFrame方法是在account路由中，没登录时请求失败，登录后不重新进入account路由
    // 的话，不会触发路由钩子，需要在此处判断一下
    const orderTimeFrame = this.$store.state.orders.orderTimeFrame
    if (!orderTimeFrame || !Array.isArray(orderTimeFrame) || !orderTimeFrame.length) {
      this.fetchOrderByTimeFrame(3);
    }
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    ordersLoading: state => state.orders.ordersLoading,
    windowWidth: state => state.navbar.windowWidth,
    filteredList() {
      let allList = this.$store.state.orders.orderTimeFrame.slice();
      if (this.filterSelected === 'all') {
        return this.$store.state.orders.orderTimeFrame;
      }
      if (this.filterSelected === 'processing') {
        return allList.filter(item => {
          const saleStatus = item.SaleStatus
          return saleStatus === 'Packing' || saleStatus === 'Open' || saleStatus === 'Picking' || saleStatus === 'Released'
        });
      }
      if (this.filterSelected === 'pending') {
        // 目前没有此状态的订单
        // let pendingPaymentList = allList.filter(item => {
        //   return item.PaymentStatus !== 'Paid'
        // });
        //  return pendingPaymentList;
        return []
      }
      if (this.filterSelected === 'completed') {
        return allList.filter(item => {
          const saleStatus = item.SaleStatus
          return saleStatus === 'Delivered' || saleStatus === 'Partially Refunded' || saleStatus === 'Refunded'
        })
      }
    },
    isMobile() {
      return this.windowWidth < 800;
    },
  }),
  watch: {
    '$store.state.orders.orderTimeFrame': {
      immidiate: true,
      handler(newval) {
        this.loaded = true;
      }
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/css/profileorder.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/order.vue